<template>
    <div class="shipment-open-report-table">
        <div class="shipment-open-report-table__table">
            <v-data-table
                :headers="headers"
                :items="wigs"
                :items-per-page="-1"
                :footer-props="{
                    'items-per-page-text': $t('pages.report.rowsPerPage'),
                }"
                :no-data-text="$t('pages.report.noDataAvailable')"
                :loading="isLoading"
                dense
                hide-default-footer
                fixed-header
                @click:row="navigateToOrder"
            >
                <!--    eslint-disable-next-line -->
                <template #item.last_shipment_date="{ item }">
                    <span class="nowrap-cell" style="direction: ltr; display: inline-block">
                        <DateCell
                            :value="item.last_shipment_date"
                            :utc="false"
                        />
                    </span>
                </template>
                <!--    eslint-disable-next-line -->
                <template #item.customer_name="{ item }">
                    {{ item.customer_name || '-' }}
                </template>
                <!--    eslint-disable-next-line -->
                <template #item.barcode="{ item }">
                    {{ item.barcode || '-' }}
                </template>
                <!--    eslint-disable-next-line -->
                <template #item.total_price="{ item }">
                    <span class="nowrap-cell">{{ formatPrice(item.total_price) }}</span>
                </template>
                <!--    eslint-disable-next-line -->
                <template #item.amount_paid="{ item }">
                    <span class="nowrap-cell">{{ formatPrice(item.amount_paid) }}</span>
                </template>
                <!--    eslint-disable-next-line -->
                <template #item.outstanding_balance="{ item }">
                    <span class="nowrap-cell">{{ formatPrice(item.outstanding_balance) }}</span>
                </template>
                <!--    eslint-disable-next-line -->
                <template #item.manager="{ item }">
                    {{ item.manager?.nickname || '-' }}
                </template>
                <!--    eslint-disable-next-line -->
                <template #item.shipment="{ item }">
                    <ShipmentDocumentLink
                        v-if="item.shipment?.document_link"
                        :link="item.shipment.document_link"
                    />
                    <span v-else>-</span>
                </template>
                <!--    eslint-disable-next-line -->
                <template #item.payments="{ item }">
                    <ShipmentOpenReportPaymentsDisplay
                        :payments="item.payments"
                    />
                </template>
            </v-data-table>
        </div>
    </div>
</template>

<script>
import DateCell from '@/components/common/cells/date-cell.vue'
import ShipmentDocumentLink from '@/components/shipments/shipment-document-link.vue'
import ShipmentOpenReportPaymentsDisplay from './shipment-open-report-payments-display.vue'

export default {
    name: 'ShipmentOpenReportTable',
    components: {
        DateCell,
        ShipmentDocumentLink,
        ShipmentOpenReportPaymentsDisplay,
    },
    props: {
        wigs: {
            type: Array,
            default: () => [],
        },
        isLoading: {
            type: Boolean,
            default: false,
        },
    },
    computed: {
        headers() {
            return [
                {
                    text: this.$t(
                        'pages.report.openShipmentReport.lastShipmentDate'
                    ),
                    value: 'last_shipment_date',
                    sortable: false,
                },
                {
                    text: this.$t('pages.report.openShipmentReport.barcode'),
                    value: 'barcode',
                    sortable: false,
                },
                {
                    text: this.$t('pages.report.client'),
                    value: 'customer_name',
                    sortable: false,
                },
                {
                    text: this.$t('pages.report.openShipmentReport.manager'),
                    value: 'manager',
                    sortable: false,
                },
                {
                    text: this.$t('pages.report.openShipmentReport.totalPrice'),
                    value: 'total_price',
                    sortable: false,
                },
                {
                    text: this.$t('pages.report.openShipmentReport.amountPaid'),
                    value: 'amount_paid',
                    sortable: false,
                },
                {
                    text: this.$t(
                        'pages.report.openShipmentReport.outstandingBalance'
                    ),
                    value: 'outstanding_balance',
                    sortable: false,
                },
                {
                    text: this.$t('pages.report.openShipmentReport.shipment'),
                    value: 'shipment',
                    align: 'center',
                    sortable: false,
                },
                {
                    text: this.$t('pages.report.openShipmentReport.payments'),
                    value: 'payments',
                    align: 'center',
                    sortable: false,
                },
            ]
        },
    },
    methods: {
        formatPrice(price) {
            return new Intl.NumberFormat('en-US', {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
            }).format(price)
        },
        navigateToOrder(item) {
            const wigId = item.id || item.wig_id || item.wig?.id
            if (wigId) {
                this.$router.push({ path: `/orders/${wigId}` })
            }
        },
    },
}
</script>

<style lang="scss" scoped>
.shipment-open-report-table {
    &__table {
        width: 100%;
        position: relative;
        &:before {
            content: '';
            position: absolute;
            top: -4px;
            left: 0;
            width: 100%;
            height: 4px;
            background: linear-gradient(
                to top,
                rgba(0, 0, 0, 0.04),
                transparent
            );
        }
    }
}

::v-deep .v-data-table-header th {
    white-space: nowrap !important;
}

::v-deep .v-data-table-header th .v-data-table-header__content {
    display: flex !important;
    align-items: center;
    gap: 6px;
}

::v-deep .v-data-table tbody tr {
    cursor: pointer;
}
</style>
